(function () {
  window.customize = window.customize || {};
  window.customize.state = window.customize.state || {};
  window.customize.data = window.customize.data || {};
  window.customize.json = window.customize.json || {};
  window.customize.language = window.customize.language || {};
  window.customize.url = window.customize.url || {};
  window.customize.url.img_directory = "/2020/img/customize/";
  window.customize.state.current_page = null;
  window.customize.state.current_parts = {};
  window.customize.state.selected_parts = window.customize.state.selected_parts || [];

  /* ============================================================
  初期化
  ============================================================ */
  function init(){
    setDefaultState();
    createHTML();
    showFirstPage();
    changePrice();
    setSelectedPartsData();
    $(".js-selectAnswerInput:checked").trigger("change");
    window.snippets.lazyload();
  }

  /* ============================================================
  デフォルト選択パラメータセット
  ============================================================ */
  function setDefaultState(){
    // 現在のページ
    window.customize.state.current_page = window.customize.data.questions[0].id;

    // selected_partsがあれば
    if (window.customize.state.selected_parts.length > 0) {
      for (let i = 0, len = window.customize.state.selected_parts.length; i < len; i=(i+1)|0) {
        const data = window.customize.state.selected_parts[i];
        if (!data) continue;  // dataがない場合は次のループへ
        const questionData = window.snippets.getObjByKeyValue(window.customize.data.questions, "id", data.id)[0];
        if (!questionData) continue;  // dataがない場合は次のループへ
        const selectedChoiceData = window.snippets.getObjByKeyValue(questionData.choices, "input_value", data.value);

        // valueがあればスキップ
        if( data.value !== null && selectedChoiceData.length > 0 ){
          continue;
        }

        // 最初の選択肢をデフォルトに
        const firstImg = questionData.choices[0].input_value;
        let value = firstImg;

        // デフォルト設定があればそちらを優先
        const defaultImg = questionData.default_img;
        const defaultImgChoiceData = window.snippets.getObjByKeyValue(questionData.choices, "input_value", defaultImg);
        if (defaultImg && defaultImgChoiceData.length > 0) {
          value = defaultImg;
        }

        data.value = value;
        data.user_selected = false;
      }
      return;
    }

    // selected_partsがなければ
    for (let i = 0, len = window.customize.data.questions.length; i < len; i=(i+1)|0) {
      const data = window.customize.data.questions[i];
      const defaultImg = data.default_img;
      const firstImg = data.choices[0].input_value;
      let value = firstImg;
      if (defaultImg) {
        value = defaultImg;
      }
      const item = {
        "id": data.id,
        "input_name": data.input_name,
        "user_selected": false,
        "value": value
      };
      window.customize.state.selected_parts.push(item);
    }
  }

  /* ============================================================
  初期DOM生成
  ============================================================ */
  function createHTML(){
    const imgDirectory = window.customize.url.img_directory,
      crt = window.customize.state.current_page,
      crtQuestionData = window.snippets.getObjByKeyValue(window.customize.data.questions, "id", crt)[0];
    let 
      questionPage = "",
      isFirstPage = true,
      isLastPage = false;

    for (let i = 0, len = window.customize.data.questions.length; i < len; i=(i+1)|0) {
      const data = window.customize.data.questions[i];
      if (i === len-1) {
        isLastPage = true;
      }
      questionPage += window.customize.module.question(data, imgDirectory, isFirstPage, isLastPage);
      if (i === 0) {
        isFirstPage = false;
      }
    }

    const html = `
      <div class="p-customizeGrid">
        ${window.customize.module.mainImg(imgDirectory, returnImgName(crtQuestionData))}
        <div class="p-customizeSelectArea">
          ${window.customize.module.step()}
          <div class="p-customizePageWrap js-customizePageWrap">
            ${questionPage}
          </div>
        </div>
      </div>
    `;
    $("#js-customizeApp").html(html);
  }

  /* ============================================================
  初期ページ表示
  ============================================================ */
  function showFirstPage(){
    const params = window.snippets.getParameter();
    const paramPage = params['page'];
    const targetPage = `.js-customizePage[data-page="${paramPage}"]`;

    if ($(targetPage).length < 1 || !paramPage) {
      showPage(window.customize.state.current_page);
      return;
    }
    showPage(paramPage);
  }

  /* ============================================================
  ページ遷移
  ============================================================ */
  function showPage(key){
    const
      $crtPage = $(`.js-customizePage[data-page="${window.customize.state.current_page}"]`),
      $nextPage = $(`.js-customizePage[data-page="${key}"]`),
      $crtStep = $(`.p-stepListItem[data-page="${window.customize.state.current_page}"]`),
      $nextStep = $(`.p-stepListItem[data-page="${key}"]`);

    $crtStep.removeClass("is-crt");
    $crtPage.fadeOut(500, function(){
      $("html, body").animate({scrollTop:0}, 0, "swing");
      $nextStep.addClass("is-crt");
      changeMainImg();
      $nextPage.fadeIn(500, function(){
      });
    });
    window.customize.state.current_page = key;
  }

  /* ============================================================
  選択
  ============================================================ */
  function checkSelectedParts(questionId){
    const $input = $(`.js-selectAnswerInput[data-question-id="${questionId}"]`);
    const crtSelectedData = window.snippets.getObjByKeyValue(window.customize.state.selected_parts, "id", questionId)[0];

    let value = null;
    
    for (let i = 0, len = $input.length; i < len; i=(i+1)|0) {
      if (!$input.eq(i).prop('checked')) {
        continue;
      }
      value = parseInt($input.eq(i).attr("value"),10);
      break;
    }

    crtSelectedData.value = value;
    crtSelectedData.user_selected = true;

    deselectConditionalChoice(crtSelectedData.input_name, value);
    setSelectedPartsData();
    changeMainImg();
    changePrice();
  }

  // 条件付きChoiceの選択解除
  function deselectConditionalChoice(input_name, input_value){
    conditional_answers = $("#js-customizeApp").find(".js-conditionalAnswer");
    // 条件付きのChoiceをループ
    for (let i = 0, len = conditional_answers.length; i < len; i=(i+1)|0) {
      const data_array = conditional_answers.eq(i).data('conditional');
      const array = data_array.split(":");
      const key = array[0];

      // このChoiceの条件が、input_nameと関係なかったらスキップ
      if(String(key) !== String(input_name)) {
        continue;
      }

      // このChoiceをjQueryオブジェクトへ
      const $input = conditional_answers.eq(i).find("input");
      // このChoiceのname
      const name = $input.attr("name");
      // このChoiceのselected_partsオブジェクト
      const crtSelectedData = window.snippets.getObjByKeyValue(window.customize.state.selected_parts, "input_name", name)[0];
      // このChoiceのQuestionオブジェクト
      const questionData = window.snippets.getObjByKeyValue(window.customize.data.questions, "id", crtSelectedData.id)[0];
      // このQuestionの最初のChoiceのValue
//      const firstImg = questionData.choices[0].input_value;
      // 選択されたChoiceの条件に合う最初のChoiceオブジェクト
      const firstObject = window.snippets.getObjByKeyValue(questionData.choices, "conditional_input_value", input_value)[0];
      // Selected_partsに代入するvalue
      let value = firstObject.input_value;

      // このQuestionのデフォルト画像設定
//      const defaultImg = questionData.default_img;
      // デフォルト画像のChoiceオブジェクト
//      const defaultImgChoiceData = window.snippets.getObjByKeyValue(questionData.choices, "input_value", defaultImg);

      // デフォルト画像の設定、Choiceオブジェクトの存在チェック
//      if (defaultImg && defaultImgChoiceData.length > 0) {
        // あればValueをデフォルト画像にする
//        value = defaultImg;
//      }

      // このChoiceの選択状態を解除
      $input.removeAttr('checked').prop('checked', false).change();

      // Selected_partsにValueを挿入
      crtSelectedData.value = value;

      // ユーザーが選択したものではないためfalseへ
      crtSelectedData.user_selected = false;

    }
  }

  function setSelectedPartsData(){
    const metal_id          = window.snippets.getObjByKeyValue(window.customize.state.selected_parts, "input_name", "metal_id")[0].value;
    const stone_id          = window.snippets.getObjByKeyValue(window.customize.state.selected_parts, "input_name", "stone_id")[0].value;
    const finishing_id      = window.snippets.getObjByKeyValue(window.customize.state.selected_parts, "input_name", "finishing_id")[0].value;
    const necklace_chain_id = window.snippets.getObjByKeyValue(window.customize.state.selected_parts, "input_name", "necklace_chain_id")[0].value;
    $("#js-customizeApp").attr({
      "data-metal_id": metal_id,
      "data-stone_id": stone_id,
      "data-finishing_id": finishing_id,
      "data-necklace_chain_id": necklace_chain_id
    });

    conditional_answers = $("#js-customizeApp").find(".js-conditionalAnswer");
    for (let i = 0, len = conditional_answers.length; i < len; i=(i+1)|0) {
      const data_array = conditional_answers.eq(i).data('conditional');
      const array = data_array.split(":");
      const key = array[0];
      const value = array[1];
      const crtValue = window.snippets.getObjByKeyValue(window.customize.state.selected_parts, "input_name", key)[0].value;
      if(String(value) === String(crtValue)) {
        conditional_answers.eq(i).show();
      } else {
        conditional_answers.eq(i).hide();
      }
    }
    
  }

  /* ============================================================
  メイン画像変更
  ============================================================ */
  function changeMainImg(){
    const $element = $(".js-previewImg");
    const elementSrc = $element.attr("src");
    const crt = window.customize.state.current_page;
    const crtQuestionData = window.snippets.getObjByKeyValue(window.customize.data.questions, "id", crt)[0];
    let imgSrc = "";

    if (!crtQuestionData.is_common_main_img) {
      imgSrc = `${window.customize.url.img_directory}${window.customize.state.jewelry_id}/main/${returnImgName(crtQuestionData)}.jpg`;
    } else {
      imgSrc = `${window.customize.url.img_directory}common/${crtQuestionData.input_name}/${returnImgName(crtQuestionData)}.jpg`;
    }

    if (imgSrc === elementSrc) {
      return;
    }

    $(".js-previewImg").attr("src", imgSrc);
  }

  /* ============================================================
  メイン画像 ファイル名生成
  ============================================================ */
  function returnImgName(crtQuestionData){
    const targetId = crtQuestionData.main_img_id;
    let imgFileName = "";

    for (let i = 0, len = targetId.length; i < len; i=(i+1)|0) {
      const data = window.snippets.getObjByKeyValue(window.customize.data.questions, "id", targetId[i])[0];
      const crtSelectedData = window.snippets.getObjByKeyValue(window.customize.state.selected_parts, "id", data.id)[0];
      const value = crtSelectedData.value;
      imgFileName += `${data.thumb_prefix}${value}`;
    }

    return imgFileName;
  }

  /* ============================================================
  価格変更
  ============================================================ */
  function changePrice(){
    const $showElement = $(".js-nowPrice");
    let html = '';
    let tableInnerHTML = '';
    let tableInnterCarvedSealRow = '';
    let totalPrice = 0;
    

    for (let i = 0, len = window.customize.data.questions.length; i < len; i=(i+1)|0) {
      const question = window.customize.data.questions[i];
      const crtSelectedData = window.snippets.getObjByKeyValue(window.customize.state.selected_parts, "id", question.id)[0];
      const isUserSelected = crtSelectedData.user_selected;
      const selectedValue = crtSelectedData.value;
      let selectedChoiceData = window.snippets.getObjByKeyValue(question.choices, "input_value", selectedValue)[0];
      let tableData = {
        "head": question.shortname,
        "name": selectedChoiceData.name,
        "price": `¥${selectedChoiceData.price.toLocaleString()}`
      }
      if (!isUserSelected) {
        tableData.name = window.customize.language.price.unselected;
        tableData.price = '-';
      } else {
        totalPrice += selectedChoiceData.price;
      }
      tableInnerHTML += `
        <tr>
          <th class="p-priceTable__head u-ws-nw">${tableData.head}</th>
          <td class="p-priceTable__name">${tableData.name}</td>
          <td class="p-priceTable__price u-ws-nw">${tableData.price}</td>
        </tr>
      `;
    }

    let carved_seal_price = "-";
    if(window.customize.state.carved_seal.price){
      carved_seal_price = "¥" + window.customize.state.carved_seal.price.toLocaleString();
      totalPrice += window.customize.state.carved_seal.price;
    }

    if(window.customize.data.settings.can_be_engraved){
      tableInnterCarvedSealRow = `
        <tr>
          <th class="p-priceTable__head u-ws-nw">${window.customize.language.carved_seal.shortname}</th>
          <td class="p-priceTable__name">${window.customize.state.carved_seal.name}</td>
          <td class="p-priceTable__price u-ws-nw">${carved_seal_price}</td>
        </tr>
      `
    }

    html = `
      <table class="p-priceTable">
        ${tableInnerHTML}
        ${tableInnterCarvedSealRow}
      </table>
      <p class="p-totalPrice">${window.customize.language.price.total}: <b>¥${totalPrice.toLocaleString()}</b></p>
    `;

    $showElement.html(html);
  }

  /* ============================================================
  数値かどうかチェック
  ============================================================ */
  function isNumber(val){
    var regexp = new RegExp(/^[-]?([1-9]\d*|0)(\.\d+)?$/);
    return regexp.test(val);
  }

  /* ============================================================
  カスタムデータ取得
  ============================================================ */
  function getCustomData($element, str){
    let value = $element.attr(`data-${str}`);

    if(isNumber(value)){
      value = parseInt(value, 10);
    }    
    return value;
  }

  /* ============================================================
  ready
  ============================================================ */
  $(function() {
    $.when(
      $.getJSON(window.customize.json.main),
      $.getJSON(window.customize.json.language)
    ).then((main, language) => {
      Object.assign(window.customize.data, main[0]);
      Object.assign(window.customize.language, language[0]);
      init();
    }, (XMLHttpRequest, textStatus, errorThrown) => {
      alert(`
        エラーが発生しました。
        XMLHttpRequest : ${XMLHttpRequest.status}
        textStatus : ${textStatus}
        errorThrown : ${errorThrown.message}
      `);
    });
  });

  /* ============================================================
  
  ============================================================ */
  /*
  window.addEventListener('popstate', function(e) {
    location.reload();
  });
  */

  window.onbeforeunload = function(e) {
    e.returnValue = "";
  }

  /* ============================================================
  
  ============================================================ */
  $(document).on("click", ".js-showPage", function (e) {
    const
      $this = $(this),
      target = $this.attr("data-target");
    let key = null;
    
    if (!target){
      console.log(`ERROR: data-target not found`);
      return;
    }

    if (target === "next") {
      key = $this.closest(".js-customizePage").next().attr("data-page");
    } else if( target === "prev") {
      key = $this.closest(".js-customizePage").prev().attr("data-page");
    } else {
      key = target;
    }

    showPage(key);
  });

  /* ============================================================
  選択肢が変わったとき
  ============================================================ */
  $(document).on("click", ".js-selectAnswerInput", function () {
    const
      $this = $(this),
      $parent = $this.closest(".js-customizePage"),
      $nextButton = $parent.find(`.js-nextButton`),
      questionId = getCustomData($this, "question-id");
      interlock = $this.attr("data-interlock-input-hidden");
      thisName = $this.attr("name");
      thisValue = $this.attr("value");
      $inputHidden = $(`input[type="hidden"][data-interlock-input-hidden="${thisName}"]`);
      $inputHidden.attr("value", thisValue);
      $nextButton.removeAttr('aria-disabled tabindex');
      $nextButton.parent(".c-button").removeClass("is-disabled");
      checkSelectedParts(questionId);
  });

  /* ============================================================
  
  ============================================================ */
  $(document).on("submit", "form", function () {
    window.onbeforeunload = null;
  });

})();
